import { Directive, EventEmitter, HostBinding, Input, Output } from '@angular/core';

export type LayoutDirection = 'ltr' | 'rtl';

/**
 * Directive to listen to changes of direction of part of the DOM.
 *
 * Applications should use this directive instead of the native attribute so that Material
 * components can listen on changes of direction.
 */
@Directive({
  selector: '[rtDir]',
  // TODO(hansl): maybe `$implicit` isn't the best option here, but for now that's the best we got.
  exportAs: '$implicit',
  standalone: true,
})
export class DirDirective {
  @Input('dir') public _dir: LayoutDirection = 'ltr';

  @Output() public dirChange: EventEmitter<void> = new EventEmitter<void>();

  // eslint-disable-next-line ban/ban
  @HostBinding('attr.dir')
  public get dir(): LayoutDirection {
    return this._dir;
  }

  public set dir(v: LayoutDirection) {
    const old = this._dir;
    this._dir = v;
    if (old !== this._dir) {
      this.dirChange.emit();
    }
  }

  public get value(): LayoutDirection {
    return this.dir;
  }

  public set value(v: LayoutDirection) {
    this.dir = v;
  }
}
